var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8723 13.7532C32.6399 16.9788 30.2471 19.4635 27.6379 19.4635C25.0286 19.4635 22.6318 16.9796 22.4034 13.7532C22.1655 10.3977 24.4948 8.04297 27.6379 8.04297C30.7809 8.04297 33.1102 10.4587 32.8723 13.7532Z",
    stroke: "#2544EE",
    strokeWidth: 2.5379,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.639 24.541C22.4704 24.541 17.5001 27.1083 16.2549 32.1079C16.09 32.7694 16.5047 33.4237 17.1844 33.4237H38.0943C38.774 33.4237 39.1864 32.7694 39.0239 32.1079C37.7787 27.0282 32.8084 24.541 27.639 24.541Z",
    stroke: "#2544EE",
    strokeWidth: 2.5379,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8574 15.1753C16.6719 17.7512 14.7383 19.78 12.654 19.78C10.5698 19.78 8.63306 17.752 8.45065 15.1753C8.2611 12.4954 10.1431 10.5801 12.654 10.5801C15.165 10.5801 17.047 12.5446 16.8574 15.1753Z",
    stroke: "#2544EE",
    strokeWidth: 2.5379,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3358 24.6991C15.9042 24.0432 14.3276 23.791 12.6565 23.791C8.53242 23.791 4.55902 25.8412 3.56369 29.8344C3.43283 30.3626 3.76434 30.8852 4.30682 30.8852H13.2117",
    stroke: "#2544EE",
    strokeWidth: 2.5379,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.a49ca932e7df26705bc96d78890d23ab.svg";
export { ForwardRef as ReactComponent };